var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { pushEventsViaApiThrottler, initalizeDumpServiceApiThrottler } from "../helpers/pushEventsToDumpService";
import { checkAndSetAdwordsUtmParams } from "./utmParams";
import { sendEventFromBERoute, isEventAllowed, isGuest, prepareAnalyticsProperties, trackCallbackMethodToSentry } from "../helpers/utils";
import * as Sentry from "@sentry/browser";
import SplashLogger from "utils/SplashLogger";
import { FE_BUFFER_REASONS } from "../helpers/utils/constants";
import { checkIfMixpanelAPIIsBlocked, checkIfMixpanelIsBlockedByBrowser, checkIfMixpanelScriptIsBlocked } from "../helpers/utils/mixpanel_helper";
var loggerName = 'CustomTrackingMethods';
var CustomTrackingMethods = /** @class */ (function () {
    function CustomTrackingMethods(params) {
        var _this = this;
        this.mixpanelBlocked = false;
        this.init = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // only define trackAnalyticsEventCore and trackClevertapEvent methods after
                    // checkIfMixpanelIsBlocked is executed.
                    // until then, events will go via BE route via buffering logic
                    return [4 /*yield*/, this.checkIfMixpanelIsBlocked()];
                    case 1:
                        // only define trackAnalyticsEventCore and trackClevertapEvent methods after
                        // checkIfMixpanelIsBlocked is executed.
                        // until then, events will go via BE route via buffering logic
                        _a.sent();
                        window.trackAnalyticsEventCore = this.trackAnalyticsEvent;
                        window.trackClevertapEvent = this.trackClevertapEvent;
                        return [2 /*return*/];
                }
            });
        }); };
        this.checkIfMixpanelIsBlocked = function () { return __awaiter(_this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, checkIfMixpanelAPIIsBlocked()];
                    case 1:
                        if (_a.sent()) {
                            this.markMixpanelAsBlocked(FE_BUFFER_REASONS.mixpanelApiBlocked);
                            return [2 /*return*/];
                        }
                        if (checkIfMixpanelScriptIsBlocked()) {
                            this.markMixpanelAsBlocked(FE_BUFFER_REASONS.mixpanelNotFound);
                            return [2 /*return*/];
                        }
                        if (checkIfMixpanelIsBlockedByBrowser()) {
                            this.markMixpanelAsBlocked(FE_BUFFER_REASONS.mixpanelBlockedByBrowser);
                            return [2 /*return*/];
                        }
                        this.mixpanelBlocked = false;
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        SplashLogger.error(loggerName, 'Error in checkIfMixpanelIsBlocked', e_1);
                        Sentry.captureException(e_1, {
                            level: "error",
                        });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.markMixpanelAsBlocked = function (blockedReason) {
            SplashLogger.debug(loggerName, "Mixpanel is blocked: ", blockedReason);
            _this.mixpanelBlocked = true;
            _this.mixpanelBlockedReason = blockedReason;
        };
        this.trackAnalyticsEvent = function (_event, properties, sendGA, callbackMethod) {
            var _a, _b, _c;
            if (_this.params.userContextApiError) {
                sendEventFromBERoute({ _event: _event, properties: properties, callbackMethod: callbackMethod, fe_buffer_reason: _this.params.userContextApiError });
                return;
            }
            if (_this.mixpanelBlocked) {
                var shouldTrackMetaSessionEvent = window.trackerProperties.metaSessionId !== undefined;
                if (!isGuest() && shouldTrackMetaSessionEvent) {
                    pushEventsViaApiThrottler(_event, properties);
                }
                sendEventFromBERoute({ _event: _event, properties: properties, callbackMethod: callbackMethod, fe_buffer_reason: _this.mixpanelBlockedReason });
                return;
            }
            properties = properties || {};
            try {
                var blacklistedEvents = _this.params.mixpanelBlacklistedEventsList;
                if (blacklistedEvents) {
                    window.mixpanel_blacklisted_events = blacklistedEvents;
                    if (window.mixpanel_blacklisted_events.indexOf(_event) !== -1) {
                        return;
                    }
                }
                var shouldTrackMetaSessionEvent = window.trackerProperties.metaSessionId !== undefined;
                if (!isGuest() && shouldTrackMetaSessionEvent) {
                    pushEventsViaApiThrottler(_event, properties);
                }
                properties = prepareAnalyticsProperties(_event, properties, _this.params);
                /**
                 *  Attach super props and send event to mixpanel
                 */
                // Mixpanel also has funda of super properties here, via the call to mixpanel.register.
                // We can use that as well to set default parameters to request.
                if (isEventAllowed(_event, properties, _this.params)) {
                    try {
                        // Adding console logs additionally due to requirement from product team
                        console.group('EVENT DISPATCHED');
                        console.info(_event);
                        console.info(properties);
                        console.groupEnd();
                        SplashLogger.debug(loggerName, 'EVENT DISPATCHED', {
                            event: _event,
                            properties: properties
                        });
                    }
                    catch (err) {
                        console.error('SOMETHING WENT WRONG in logging -- trackAnalyticsEvent', err.message);
                    }
                    var mixpanelInstance = window.getMixpanelInstance((_a = window.trackerProperties) === null || _a === void 0 ? void 0 : _a.analyticsId);
                    if (window.mixpanel_blocked_events.indexOf(_event) === -1) {
                        // This is to ensure that the event is always triggered even in cases where
                        // a redirect happens right after the triggering call.
                        _this.trackClevertapEvent(_event, properties);
                        if (_event === "Product Purchased Frontend") {
                            window.trackServerSide(_event, properties, null);
                            return;
                        }
                        mixpanelInstance.track(_event, properties);
                        if (_event === "Interacted Grade Selection") {
                            window.trackServerSide("Interacted Grade Selection BE", properties, null);
                        }
                    }
                }
            }
            catch (err) {
                SplashLogger.error(loggerName, {
                    msg: "Error in trackAnalyticsEvent",
                    event: _event,
                    properties: properties
                }, err);
                Sentry.captureException(err, {
                    extra: { event: _event, properties: properties, analyticsId: (_b = window.trackerProperties) === null || _b === void 0 ? void 0 : _b.analyticsId },
                    level: "error",
                });
            }
            // moved this code to finally block to ensure callback method is executed everytime without fail
            finally {
                _this.executeCallbackMethod(callbackMethod, _event, (_c = window.trackerProperties) === null || _c === void 0 ? void 0 : _c.analyticsId);
            }
        };
        this.trackClevertapEvent = function (event, properties) {
            var AllowedEvents = _this.params.clevertapAllowedEvents;
            // Make a deep copy of properties to prevent mutation
            var clevertapProperties = JSON.parse(JSON.stringify(properties));
            // The first check means empty list returned by Clevertap.allowed_events
            // In this case, trackServerSide anyway and let BE handle the filtering
            if (AllowedEvents == "[]" || AllowedEvents.indexOf(event) !== -1) {
                window.trackServerSide(event, clevertapProperties, null, true);
            }
        };
        this.params = params;
        initalizeDumpServiceApiThrottler(params);
        checkAndSetAdwordsUtmParams();
    }
    CustomTrackingMethods.prototype.executeCallbackMethod = function (callbackMethod, event, analyticsId) {
        if (callbackMethod && typeof (callbackMethod) === "function") {
            try {
                trackCallbackMethodToSentry(callbackMethod, event, "executeCallbackMethod");
                callbackMethod();
            }
            catch (e) {
                if (WebCoreUIConfig.env === 'development' || WebCoreUIConfig.env === 'staging') {
                    SplashLogger.error(loggerName, 'Error in mixpanel event callback', e);
                }
                SplashLogger.error(loggerName, 'SOMETHING WENT WRONG -- 4');
                Sentry.captureException(e, {
                    tags: { analyticsId: analyticsId },
                    level: "error",
                });
            }
        }
    };
    return CustomTrackingMethods;
}());
export { CustomTrackingMethods };
